const DesignPage = () => {
  return <div className='flex h-screen'></div>;
};

export default DesignPage;
